<template>
  <v-btn variant="text" class="custom-icon-btn" />
</template>
<script setup lang="ts"></script>
<style scoped>
.custom-icon-btn {
  padding: 0 !important;
  width: var(--v-btn-height) !important;
  height: var(--v-btn-height) !important;
}
</style>
